
import { APIClient } from "api/api_helper";
import { DOSING_SCHEDULE_API, SUBJECT_API, TIMEPOINTS_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// DOSING SCHEDULE API
// ------------------------------------------------------------------

export const dosingScheduleApiService = {

    // SELECT ALL METHOD
    selectAllData: (payload: any) => {
        return api.create(
            DOSING_SCHEDULE_API.DOSING_SCHEDULE_API + "SelectAll",
            payload
        );
    },

    // INSERT METHOD
    insertData: (data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            ...data,
            createdby: user.userid,
        
        };

        return api.create(
            DOSING_SCHEDULE_API.DOSING_SCHEDULE_API + "Insert",
            payload
        );
    },

    // UPDATE METHOD
    updateData: (data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            ...data,
            updatedby: user.userid,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        return api.create(
            DOSING_SCHEDULE_API.DOSING_SCHEDULE_API + "Update",
            payload
        );
    },

    // UPDATE SUBJECT DOSETIME METHOD
    updateSubjectDoseTime: (payload: {
        studyid: number;
        subjectdosingeventid: number;
        scheduleddosetime: string;
    }) => {
        return api.create(SUBJECT_API.UPDATE_DOSETIME, payload);
    },

    // SELECT TIMEPOINT EXECUTION
    selectTimepointExecution: (payload: {
        studyid: number;
        periodid: number;
        timepoint_number: string | number;
        search?: string;
        currentpage?: number;
        pagesize?: number;
    }) => {
        const user = GetUserData() as CurrentUser;
        return api.create(TIMEPOINTS_API.TIMEPOINTS_API + "Select", {
            ...payload,
        });
    },

    // VERIFY DOSING SCHEDULE
    verifyData: (payload: {
        studyid: number;
        periodid: number;
        subjectsperstation: Record<string, string[]>;
        verifypin: string;
        verifiedby: number;
    }) => {
        return api.create(
            DOSING_SCHEDULE_API.DOSING_SCHEDULE_API + "Verify",
            payload
        );
    },

    // GET DOSING REPORT
    getDosingReport: (payload: { studyid: number; periodid: number }) => {
        return api.create(
            DOSING_SCHEDULE_API.DOSING_SCHEDULE_API + "Report",
            payload,
            { responseType: 'blob' }
        );
    },
};

